import { get, chain, omit, isEmpty } from "lodash"
import { createReducer } from "reduxsauce"
import { put, takeLatest } from "redux-saga/effects"
import createActions from "helpers/actionCreator"
import { getUserPreference } from "helpers/userPreferences"
import { computeUpdatedFilters } from "helpers/filters"
import { Types as LoaderTypes, Creators as modelCreators } from "model/data"
import { Creators as filterSaverCreators } from "modules/filter-saver/model"
import { getModuleSelectedColumns } from "./selectors"

export const { Types, Creators } = createActions("ompnt/modules/securities-finder", {
  setPage: ["page"],
  setFilter: ["filter"],
  updateFilters: {
    props: ["filter", "context"],
    track: true,
    trackType: ({ context }) => {
      const prefix = context ? `${context}-` : ""
      return `${prefix}market-screener-filter-selection`
    },
    trackPayload: ({ filter }) => ({ filter }),
  },
  resetFilters: [],
  loadFilters: ["filter"],
  setDate: ["date"],
  setSort: ["sort"],
  toggleFacet: ["facetType", "id"],
  toggleClassificationFacets: ["facetType", "tier", "ids", "selected"],
  setSelectedColumns: {
    props: ["columns", "modelId"],
    updatePreference: {
      getItems: (state, { modelId }) => [{
        type: "securityFinderSelectedColumns",
        value: getModuleSelectedColumns(state),
        key: modelId,
      }],
    },
  },
})

const DEFAULT_STATE = {
  filter: null,
  editing: null,
  selectedDate: null,
  selectedColumns: null,
  page: 0,
  sort: null,
}

function handleUpdateFilters(state, { filter }) {
  return { ...state, ...computeUpdatedFilters(filter) }
}

function handleSetFilter(state, { filter }) {
  return { ...state, filter }
}

function handleSetDate(state, { date }) {
  return { ...state, selectedDate: date }
}

function handleResetFilters(state) {
  return { ...state, ...DEFAULT_STATE }
}

function handleLoadFilters(state, { filter }) {
  return { ...state, filter }
}

function handleSetPage(state, { page }) {
  return { ...state, page }
}

function handleSetSort(state, { sort }) {
  return { ...state, sort }
}

function handleToggleFacet(state, { facetType, id }) {
  const toggled = get(state, [facetType, id], false)
  if (!toggled) {
    return { ...state, [facetType]: { ...state[facetType], [id]: true } }
  } else {
    return { ...state, [facetType]: omit(state[facetType], id) }
  }
}

function handleToggleClassificationFacets(state, { facetType, tier, ids, selected }) {
  // eg: { GICS: {}, GICSPlus: {}, custom1: {}}
  const currentClassifications = state.classifications
  const currentClassification = get(state, ["classifications", facetType], {})

  return {
    ...state,
    classifications: {
      ...currentClassifications,
      [facetType]: {
        ...currentClassification,
        ...chain(ids).mapKeys(id => id).mapValues(() => ({ tier, selected })).value(),
      },
    },
  }
}

function handleSetSelectedColumns(state, { columns }) {
  return { ...state, selectedColumns: columns }
}

function handleLoadSuccess(state, action) {
  if (action.resource === "securityFinderPreferences") {
    const selectedColumns = getUserPreference(action.data, "securityFinderSelectedColumns", null)
    return { ...state, ...(isEmpty(selectedColumns) ? { selectedColumns: null } : { selectedColumns }) }
  }
  return state
}

export default createReducer(DEFAULT_STATE, {
  [Types.UPDATE_FILTERS]: handleUpdateFilters,
  [Types.SET_DATE]: handleSetDate,
  [Types.SET_FILTER]: handleSetFilter,
  [Types.RESET_FILTERS]: handleResetFilters,
  [Types.LOAD_FILTERS]: handleLoadFilters,
  [Types.SET_PAGE]: handleSetPage,
  [Types.SET_SORT]: handleSetSort,
  [Types.TOGGLE_FACET]: handleToggleFacet,
  [Types.TOGGLE_CLASSIFICATION_FACETS]: handleToggleClassificationFacets,
  [Types.SET_SELECTED_COLUMNS]: handleSetSelectedColumns,
  [LoaderTypes.LOAD_SUCCESS]: handleLoadSuccess,
})

function* loadFilter() {
  yield put(modelCreators.resetCollections(["foundSecurities"]))
  yield put(filterSaverCreators.setCurrentFilter())
}

export function* saga() {
  yield takeLatest(Types.LOAD_FILTERS, loadFilter)
}
